import React from 'react';
import { InfoIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { collectionBenefits, collectionIntro } from '../data/content';
export function CollectionIntro() {
  return <section id="collection" aria-labelledby="collection-heading" className="w-full scroll-mt-16 border-t border-charcoal/10 bg-white px-5 py-14 md:px-8 md:py-24" data-id="element-43" data-mp="1ldknq7ozo1g">
      <div className="mx-auto w-full max-w-content" data-id="element-44" data-mp="353dkuj70ap4i">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-end lg:gap-16" data-id="element-45" data-mp="30410c53lxu53">
          <Reveal data-id="element-46" data-mp="3esoss2i5pnqt">
            <SectionHeading id="collection-heading" eyebrow={collectionIntro.eyebrow} title={collectionIntro.title} align="left" data-id="element-47" data-mp="3et6xlnivxaac" />
          </Reveal>
          <Reveal delay={0.04} data-id="element-48" data-mp="2mbcekvrwjwl2">
            <p className="text-base leading-relaxed text-charcoal/75 md:text-lg" data-id="element-49" data-mp="2majiqpuherhp">
              {collectionIntro.body}
            </p>
          </Reveal>
        </div>

        <ul className="mt-12 grid gap-10 md:mt-16 md:grid-cols-3 md:gap-8" data-id="element-50" data-mp="1xn9tzwvo9v7r">
          {collectionBenefits.map((benefit, index) => <Reveal as="li" key={benefit.title} delay={index * 0.05} className="border-t border-brass pt-6" data-id="element-51" data-mp="21nto0rky8ipo" data-mpi={index}>
              <h3 className="font-serif text-2xl font-semibold leading-tight text-charcoal md:text-[1.75rem]" data-id="element-52" data-mp="2bf7u5i7eogrs">
                {benefit.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-charcoal/75 md:text-[17px]" data-id="element-53" data-mp="1iqirheqpc3dx">
                {benefit.text}
              </p>
            </Reveal>)}
        </ul>

        <p className="mt-12 flex items-start gap-3 rounded-xl bg-sage/60 px-5 py-4 text-[15px] font-medium leading-relaxed text-forest md:mt-14 md:inline-flex md:items-center" data-id="element-54" data-mp="1soyizitn5eny">
          <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 md:mt-0" aria-hidden="true" data-id="element-55" data-mp="2z7ocltv22arm" />
          {collectionIntro.note}
        </p>
      </div>
    </section>;
}